import DashboardLayout from "@/pages/dashboard/components/DashboardLayout";

export default function ContractPage() {
  const signedAt = sessionStorage.getItem("contract_signed_at") || "March 28, 2026 at 10:42 AM EST";
  return (
    <DashboardLayout>
      <div className="space-y-6 max-w-2xl">
        <div><h1 className="text-2xl font-bold text-gray-900">Contract</h1><p className="text-gray-500 text-sm mt-1">Your signed installer partner agreement</p></div>
        <div className="bg-white border border-gray-100 rounded-2xl p-6 space-y-5">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 bg-green-100 rounded-2xl flex items-center justify-center"><i className="ri-file-text-line text-[#16a34a] text-2xl"></i></div>
            <div>
              <p className="font-bold text-gray-900">Installer Partner Agreement</p>
              <p className="text-sm text-gray-500">Solar Lead Source · Digital Signature</p>
            </div>
            <span className="ml-auto bg-green-100 text-green-700 text-xs font-bold px-3 py-1.5 rounded-full flex items-center gap-1"><i className="ri-shield-check-line"></i>Signed</span>
          </div>
          <div className="border-t border-gray-100 pt-5 grid grid-cols-2 gap-4 text-sm">
            {[
              { label: "Status", value: "Signed & Verified" },
              { label: "Signed At", value: signedAt },
              { label: "Agreement Version", value: "v2.1 — April 2026" },
              { label: "Signature Type", value: "Electronic (E-SIGN Act)" },
            ].map(item => (
              <div key={item.label} className="bg-gray-50 rounded-xl p-3">
                <p className="text-gray-400 text-xs mb-1">{item.label}</p>
                <p className="font-semibold text-gray-900">{item.value}</p>
              </div>
            ))}
          </div>
          <div className="bg-amber-50 border border-amber-200 rounded-xl px-4 py-3 text-xs text-amber-700 flex items-start gap-2">
            <i className="ri-information-line mt-0.5 flex-shrink-0"></i>
            <span>Your electronic signature is legally binding under the Electronic Signatures in Global and National Commerce Act (E-SIGN Act). A copy has been sent to your registered email.</span>
          </div>
          <button className="flex items-center gap-2 border border-gray-200 text-gray-700 px-5 py-2.5 rounded-lg text-sm font-medium hover:bg-gray-50 transition cursor-pointer whitespace-nowrap">
            <i className="ri-download-line"></i>Download PDF Copy
          </button>
        </div>
      </div>
    </DashboardLayout>
  );
}
